<script>
import $ from 'jquery';

export default {
  name: 'InputValidated',
  updated: function() {
    // use the global "$" variable. Yes, very tricky.
    window.$('.step5').validate({ // initialize the plugin
      ignore: ':hidden:not(#keycode)',
      rules: {
        email: {
          required: true,
          email: true
        },
        password: {
          required: true,
          minlength: 4
        }
        // keycode: {
        //   required: function() {
        //     // eslint-disable-next-line no-undef
        //     return grecaptcha.getResponse() === '';
        //   }
        // }
      },
      messages: {
        email: {
          required: 'Please enter a valid email address.',
          email: 'Please enter a valid email address.'
        },
        password: {
          required: 'Please select a password.',
          minlength: 'Password should be 4 characters.'
        }
        // keycode: {
        //   required: "Please Verify You're Not a Robot"
        // }
      },
      errorPlacement: function(error, element) {
        if (element.attr('name') === 'email') {
          $('#validation_error_email').html(error);
        }
        if (element.attr('name') === 'password') {
          $('#validation_error_password').html(error);
        }
        if (element.attr('name') === 'keycode') {
          $('#validation_error_captcha').html(error);
        }
      },
      submitHandler: function () {
        if ($('.js-submit-once').data('submitted')) {
          return false;
        } else {
          $('.js-submit-once').data('submitted', true);
          $('#submit_btn').val('Loading...');
        }
      }
    });

    // eslint-disable-next-line no-unused-vars
    function PasswordChanged(txt) {
      $(txt).prev().val($(txt).val());
    }
  }
}

</script>
